var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"individual-no-ticket-metadata shop-module"},[(_vm.tickets.length < 1)?_c('div',{staticClass:"ot-card"},[_vm._v(" "+_vm._s(_vm.$t( 'external.swinkels.individual_no_ticket_metadata.description' ))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }